import React from "react";

export default function BrandMark({ size = 40, className = "" }) {
  return (
    <div
      className={`relative inline-flex items-center justify-center rounded-md bg-brand text-white ${className}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <span
        className="font-serif italic leading-none"
        style={{ fontSize: size * 0.62, marginTop: -2 }}
      >
        A
      </span>
      <span
        className="absolute right-1 bottom-1 h-1.5 w-1.5 rounded-full bg-white"
        style={{ boxShadow: "0 0 0 2px #ff4e15" }}
      />
    </div>
  );
}
